@if (events().length > 0) {
<section class="order-timeline info-card">
  <h2 class="order-timeline__title">{{
    'staff.orders.cockpit.timeline.title' | translate
  }}</h2>

  <ol class="order-timeline__list">
    @for (event of events(); track event.id) {
    <li class="order-timeline__item">
      <time class="order-timeline__time" [attr.datetime]="event.created_at">{{
        event.created_at | date:'dd.MM.yyyy, HH:mm'
      }}</time>
      @if (presentation(event); as view) {
      <p class="order-timeline__summary">
        {{
          view.titleParams
            ? (view.titleKey | translate: view.titleParams)
            : (view.titleKey | translate)
        }}
      </p>
      @if (view.detail) {
      <p class="order-timeline__detail">{{ view.detail }}</p>
      }
      }
    </li>
    }
  </ol>
</section>
}
